"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.doRequirementClientInfo = exports.doRequirementGet = exports.doRequirementSave = exports.doRequirementList = exports.doRequirementInit = void 0;
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const api_1 = __importDefault(require("constants/api"));
const constants_1 = require("constants/constants");
const doRequirementInit = async ({ params, callback, }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    const clientDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
    const clientDataJSON = JSON.parse(clientDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "requerimiento.init",
        token: loginDataJSON.token,
        cliid: clientDataJSON.id,
    }));
    callback?.onLoading?.(true);
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                callback?.onFail?.(json.msg);
                break;
        }
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doRequirementInit = doRequirementInit;
const doRequirementList = async ({ params, callback, }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    const clientDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
    const clientDataJSON = JSON.parse(clientDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "requerimiento.list",
        token: loginDataJSON.token,
        cliid: clientDataJSON.id,
        data: {
            cardCode: params?.data.cardCode,
        },
    }));
    callback?.onLoading?.(true);
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                callback?.onFail?.(json.msg);
                break;
        }
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doRequirementList = doRequirementList;
const doRequirementSave = async ({ params, callback, }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    const clientDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
    const clientDataJSON = JSON.parse(clientDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "requerimiento.save",
        token: loginDataJSON.token,
        cliid: clientDataJSON.id,
        data: {
            cardCode: params?.data.cardCode, //"C205685745",
            direccion: params?.data.direccion, //"Av. los alamos 5588",
            direccionId: params?.data.direccionId, //"Av. los alamos 5588",
            marca: params?.data.marca, //"1",
            tipo: params?.data.tipo, //"2",
            objetivo: params?.data.objetivo, //"3",
            telefono: params?.data.telefono, //"5874478899",
            correo: params?.data.correo, //"jhon@doe.com",
            textoPanel: params?.data.textoPanel, //"texto panel",
            observaciones: params?.data.observaciones, //"observaciones",
            numFiles: params?.data.numFiles, //2,
        },
    }));
    params?.files?.forEach((item, index) => {
        formData.append(`file${index + 1}`, item);
    });
    callback?.onLoading?.(true);
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                callback?.onFail?.(json.msg);
                break;
        }
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doRequirementSave = doRequirementSave;
const doRequirementGet = async ({ params, callback, }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    const clientDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
    const clientDataJSON = JSON.parse(clientDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "requerimiento.get",
        token: loginDataJSON.token,
        cliid: clientDataJSON.id,
        data: {
            id: params?.data.id,
        },
    }));
    callback?.onLoading?.(true);
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                callback?.onFail?.(json.msg);
                break;
        }
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doRequirementGet = doRequirementGet;
const doRequirementClientInfo = async ({ params, callback }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    const clientDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
    const clientDataJSON = JSON.parse(clientDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "requerimiento.cliente.info",
        token: loginDataJSON.token,
        cliid: clientDataJSON.id,
        data: {
            cardCode: params?.data.cardCode,
        },
    }));
    callback?.onLoading?.(true);
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                callback?.onFail?.(json.msg);
                break;
        }
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doRequirementClientInfo = doRequirementClientInfo;
